import React from "react";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { Col, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import TextError from "../../helpers/FormikHelper/TextError";
import userServices from "../../services/user.services";
import { toast } from 'react-toastify';
import { CenterSchema } from "../../schema/CenterSchema";
import xrayBookingsServices from "../../services/xrayBookings.services";

const initialValues = {
    center_id:'',
}

const XrayBookingForm = ({ toggle, isAddMode, getAllBookings, selectedRow,centers }) => {  
     const savedValues = {
        center_id: '',
    }
    const onSubmit = async (values) => {
        const reqBody = {
            center_id: values.center_id,
        }
       if(isAddMode==='Add'){
        const result = await userServices.createUser(reqBody);
        if (result.data.status === true) {
            // actions.resetForm();
            getAllBookings()
            toggle()
            toast.success('User registration successfully', { toastId: 'registration_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'registration_fail', autoClose: 3000 });
        }
    }else{
        const reqBody = {
            center_id: values.center_id,
        }
        const result = await xrayBookingsServices.assignCenter(selectedRow?._id,reqBody)
        if (result.data.status === true) {
            // actions.resetForm();
            getAllBookings()
            toggle()
            toast.success(result.data.message, { toastId: 'update_success', autoClose: 3000 });
        } else {
            toast.error(result.data.message, { toastId: 'update_fail', autoClose: 3000 });
        }
    }
    }
    return (
        <React.Fragment>
            <Formik
                initialValues={isAddMode==='Add'?initialValues:savedValues}
                // validationSchema={CenterSchema('ADD_CENTER_USER')}
                onSubmit={onSubmit}
                enableReinitialize
            >
               {({  setFieldValue, values }) => (  <Form>
                    <ModalHeader toggle={toggle}>
                        <div className="card-title d-flex align-items-center">
                            <div>
                                <i className="bx bxs-user me-1 font-22 text-primary" />
                            </div>
                            <h5 className="mb-0 text-primary">{isAddMode === 'Add' ? 'Add Operator' : 'Assign Center'}</h5>
                        </div>
                    </ModalHeader>
                    <ModalBody className="">
                        <Col md={12}>
                            <div className="row g-3" >
                            <div className="col-md-12">
                                    <label htmlFor="center_id" className="form-label">
                                        Center Name
                                    </label>
                                    <Field as='select' className='form-select' id="center_id" name="center_id" >
                                        <option  value="">Select Center</option>
                                        {
                                            centers.map((e, key) => {
                                                return <option key={key} value={e._id}>{e.center_name}</option>;
                                            })
                                        }
                                    </Field>
                                    <ErrorMessage name="center_id" component={TextError} />
                                </div>
                                                   
                              
                            </div>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={toggle}
                        >
                            Close
                        </button>
                        <button type="submit" className="btn btn-primary px-5">
                        {isAddMode === "Add" ? "Save" : "Update"}
                        </button>
                    </ModalFooter>
                </Form>
 )}
            </Formik>
        </React.Fragment>
    );
}

export default XrayBookingForm;